/* ==========================================================================
  Filter prestation with AJAX in taxonomy-thematique.php pages
========================================================================== */

function reInitJSModules() {

  $('.masonry-gallery').masonry({
    itemSelector: '.gallery-item',
    columnWidth: '.gallery-sizer',
    gutter: '.gutter-sizer',
    percentPosition: true,
  });

  if (document.querySelectorAll('.lightbox').length > 0) {
    try {
      new Tobi({
        closeText: theme_strings_lightbox.closeText,
        navText: [theme_strings_lightbox.prevText, theme_strings_lightbox.nextText],
        navLabel: [theme_strings_lightbox.prev, theme_strings_lightbox.next],
        closeLabel: theme_strings_lightbox.close,
        loadingIndicatorLabel: theme_strings_lightbox.loading,
        captionsSelector: 'self',
        captionAttribute: 'data-caption',
        zoom: false,
      });
    } catch (e) {
      console.log(e);
    }
  }

}

(function($) {

  var uri = window.location.toString();

  // Remove query var periode
  if (uri.indexOf("?") > 0) {
    var base_uri = uri.substring( 0, uri.indexOf("?") );
    window.history.replaceState({}, document.title, base_uri);
  } else {
    $.each( $("input[name='periode[]']:checked"), function(){
      $(this).prop("checked", false);
    });
  }


  /**
   * AJAX function
   */
  function filterPrestations() {

    var periodes = [];

    $.each( $("input[name='periode[]']:checked"), function(){
      periodes.push($(this).val());
    });

    var form                = $('#periodes-filters'),
        activeFilterArea    = $('#active-filters'),
        resultArea          = $('#grid-prestations'),
        headerArea          = $('.prestations-container__header'),
        additionnalSection  = $('.prestations-container__additionnal'),
        datas               = {
          action:     'prestation_filter',
          periodes:   periodes,
          thematique: opt.currentTerm,
          nonce:      opt.nonce
        };

    $.ajax({

      url:        opt.ajaxUrl,
      data:       datas,
      type:       form.attr('method'),
      beforeSend:function(xhr) {
        $('.ajax-loading').addClass('is-active');
      },
      success:function(data){

        resultArea.html(data.result);
        activeFilterArea.html(data.filters);

        if( data.sections.length > 0 ) {

          additionnalSection.html(data.sections);
          reInitJSModules();

        }

      },
      complete:function(jqXHR, textStatus ){
        $('.ajax-loading').removeClass('is-active');
      },

    });

    // Add CSS class or not if subheader have active filters
    if( periodes.length > 0 ) {
      if( ! headerArea.hasClass('prestations-container__header--active') ) {
        headerArea.addClass('prestations-container__header--active');
      }
    } else {
      if( ! $('.prestations-container__header__current').length ) {
        headerArea.removeClass('prestations-container__header--active');
      }
    }

  }

  /**
   * AJAX filter with periode terms
   * global opt object : { "ajaxUrl","currentTerm","nonce"}
   */
  $('#periodes-filters input').on('change', function() {

    filterPrestations();

    return false;

  });

  /**
   * Remove periode terms filters
   */
  $('#active-filters').on('click', '.filter-tag__remove', function() {

    var button = $(this),
        parent = button.parent(),
        target = parent.attr('data-filter');

    $("input[type=checkbox][value=" + target + "]").prop("checked",false);

    parent.remove();

    filterPrestations();

  });

})( jQuery );
